import { graphql } from "@/gql";

export const confirmBookingSupplierConfirmationMutation = graphql(`
  mutation ConfirmBookingSupplierConfirmation($id: ID!) {
    confirmBookingSupplierConfirmation(id: $id) {
      id
      status
    }
  }
`);

export const dismissBookingSupplierConfirmationMutation = graphql(`
  mutation DismissBookingSupplierConfirmation($id: ID!) {
    dismissBookingSupplierConfirmation(id: $id) {
      id
      status
    }
  }
`);
